/**
 *
 * Asynchronously loads the component for ShipperCreation
 *
 */

import ReactLoadable from 'react-loadable'

export default ReactLoadable({
  loader: () => import('./index'),
  loading: () => null
})
